import { AddressBookContextState } from './address-book-context-types';

export const initialAddressBookState: AddressBookContextState = {
  isBulkUploadDialogOpen: false,
  isValidationModalOpen: false,
  addressesWithErrors: [],
  isTooManyErrorsDialogOpen: false,
  isSkipAllErrorsDialogOpen: false,
};
